document.addEventListener("DOMContentLoaded", () => {
  const btn = document.getElementById("notify-button");
  const modal = document.getElementById("notify-modal");
  const close = document.getElementById("notify-close");
  const send = document.getElementById("notify-send");

  if (!btn || !modal) return;

  // Move modal to body to avoid stacking context issues
  document.body.appendChild(modal);

  btn.addEventListener(
    "click",
    (e) => {
      modal.classList.remove("hidden");
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    },
    true,
  );

  close.addEventListener("click", () => {
    modal.classList.add("hidden");
  });

  send.addEventListener("click", async () => {
    const email = document.getElementById("notify-email").value;

    await fetch(
      "https://n8n.srv1336295.hstgr.cloud/webhook/new-back-in-stock-user",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          product_id: btn.dataset.product,
          variant_id: btn.dataset.variant,
          variant_value: btn.dataset.variantvalue,
          shopify_url: window.location.href,
        }),
      },
    );

    modal.classList.add("hidden");
  });
});
